<template>
	<div>
		<div v-if="currentQuestion === 40">

			<template v-if="showAllAnswers">
				<h3>{{copy.chosen_answers}}</h3>
				<div v-for="answeredQuestion in answeredQuestions" :key="answeredQuestion.answer.id" class="mt-10 item">
					<h4 v-html="answeredQuestion.question.id +'. ' +answeredQuestion.question.question"></h4>
					<ul class="answers neutral">
						<li v-for="answer in answeredQuestion.question.answers" :key="answer.id" :class="answer.id === answeredQuestion.answer.answer.id ? 'active' : ''" v-html="answer.answer"></li>
					</ul>
				</div>
				<div class="action p-6 mt-10">
					<h3>
						{{copy.title_todo}}
					</h3>
					<ul>
						<li v-for="todo in todos" :key="todo.question.id">
							<p v-if="todo.answer.answer.text !== ''" v-html="todo.answer.answer.text"></p>
							<p v-if="todo.answer.answer.action !== ''" v-html="todo.answer.answer.action"></p>
						</li>
					</ul>
				</div>

				<button class="button button--ghost mt-10" @click="resetAnswers">
					{{copy.cta_otherthemes}}
				</button>

				<div class="flex justify-end mt-10 print">
					<div>
						<button class="button button--underline flex items-center" @click="printAnswers">
							<inline-svg :src="require('../assets/print.svg')" />
							{{copy.cta_print}}
						</button>
					</div>
				</div>
			</template>

			<template v-else>
				<div class="item">

					<div class="action p-6">
						<h3>
							{{copy.title_todo}}
						</h3>
						<ul>
							<li v-for="todo in todos" :key="todo.question.id">
								<p v-if="todo.answer.answer.text !== ''" v-html="todo.answer.answer.text"></p>
								<p v-if="todo.answer.answer.action !== ''" v-html="todo.answer.answer.action"></p>
							</li>
						</ul>
					</div>
					<div class="flex justify-between mt-10">
						<button class="button button--ghost" v-if="this.$store.state.current > 1" @click="previousQuestion">
							&larr; {{copy.cta_prev_question}}
						</button>

						<button class="button button--primary" @click="showAnswers">
							{{copy.cta_allanswers}} &rarr;
						</button>
					</div>
				</div>
				<button class="button button--underline button--small mt-4" @click="resetAnswers">
					{{copy.cta_otherthemes}}
				</button>
			</template>

		</div>

		<div v-else>
			<div class="item">
				<div v-if="activeQuestion.question.description !== ''" class="description p-6" v-html="activeQuestion.question.description"></div>
				<div>
					<h4 class="question" v-html="activeQuestion.question.id + '. ' + activeQuestion.question.question"></h4>
					<ul class="answers mt-6">
						<li v-for="answer in activeQuestion.question.answers" :key="answer.id" @click="changeQuestion(answer)" :class="activeQuestion.answer && answer.id == activeQuestion.answer.answer.id ? 'active' : ''" v-html="answer.answer"></li>
					</ul>
				</div>

				<div class="mt-10" v-if="this.$store.state.current > 1">
					<button class="button button--ghost" @click="previousQuestion">
						&larr; {{copy.cta_prev_question}}
					</button>
				</div>
			</div>
			<a href="https://www.ugent.be/intranet/nl/op-het-werk/onderzoek-onderwijs/onderzoek/context/ethiek/overzicht.htm" class="button button--underline mt-4 block" v-if="this.$store.state.current === 1" @click="resetAnswers">
				&larr; {{copy.cta_research}}
			</a>
			<button class="button button--underline button--small mt-4" v-if="this.$store.state.current > 1" @click="resetAnswers">
				{{copy.cta_backtostart}}
			</button>
		</div>
	</div>
</template>

<script>
	import InlineSvg from "vue-inline-svg";

	export default {
		components: {
			InlineSvg,
		},
		computed: {
			copy: function () {
				return this.$store.state.copy[0][this.$store.state.language];
			},
			activeQuestion: function () {
				let q = Object.values(
					this.$store.state.questions[0][this.$store.state.language]
				).filter((question) => question.id === this.$store.state.current);

				let a = this.$store.state.answers.filter(
					(answer) => answer.id === this.$store.state.current
				);

				return { question: q[0], answer: a[0] };
			},
			currentQuestion: function () {
				return this.$store.state.current;
			},
			answeredQuestions: function () {
				let answerObj = [];

				Object.values(this.$store.state.answers).forEach(
					function (answer) {
						let q = this.$store.state.questions[0][
							this.$store.state.language
						].filter(function (question) {
							return question.id === answer.id;
						});
						answerObj.push({
							question: q[0],
							answer: answer,
						});
					}.bind(this)
				);
				return answerObj;
			},
			todos: function () {
				let todoObj = [];

				Object.values(this.$store.state.answers).forEach(
					function (answer) {
						let q = this.$store.state.questions[0][
							this.$store.state.language
						].filter(function (question) {
							return question.id === answer.id;
						});
						if (
							answer.answer.text !== "" ||
							answer.answer.action !== ""
						) {
							todoObj.push({
								question: q[0],
								answer: answer,
							});
						}
					}.bind(this)
				);

				return todoObj;
			},
			lastAnsweredQuestion: function () {
				let lastAnswerObj = [];

				let lastAnswer =
					this.$store.state.answers[
						Object.keys(this.$store.state.answers).pop()
					];

				let q = this.$store.state.questions[0][
					this.$store.state.language
				].filter(
					function (question) {
						return question.id === lastAnswer.id;
					}.bind(this)
				);

				lastAnswerObj = {
					question: q[0],
					answer: lastAnswer,
				};
				return lastAnswerObj;
			},
			showAllAnswers: function () {
				return this.$store.state.showAnswers;
			},
		},
		methods: {
			changeQuestion: function (answer) {
				this.$store.commit("add", {
					id: this.$store.state.current,
					answer: answer,
				});

				this.$store.commit("updateprev", this.$store.state.current);
				this.$store.commit("update", answer.next);
			},
			previousQuestion: function () {
				this.$store.commit("previous");
				this.$store.commit("hide");
			},
			showAnswers: function () {
				this.$store.commit("show");
			},
			resetAnswers: function () {
				this.$store.commit("reset");
				this.$store.commit("update", 1);
				this.$store.commit("updateprev", 1);
				this.$store.commit("hide");
			},
			printAnswers: function () {
				window.print();
			},
		},
	};
</script>


<style lang="scss">

	$primary: #1e64c8;
	$secondary: #e9f0fa;

	$white: #ffffff;
	$grey: #f0f0ec;
	$dark: #0a0a0a;

	.item {
		margin-top: 2rem;
		padding: 1.5rem;
		border: 1px solid $grey;
		&:first-of-type {
			margin-top: 1rem;
		}
		@media print {
			margin-top: 1.5rem;
		}
		ul {
			li {
				list-style-type: disc;
				margin-left: 2.5rem;
				&:hover {
					background-color: transparent;
				}
			}
			&.answers {
				li {
					position: relative;
					background-color: $grey;
					padding: 0.8rem 4rem 0.8rem 1.2rem;
					cursor: pointer;
					transition: all 0.3s ease-out;
					margin-left: 0;
					list-style-type: none;
					@media print {
						-webkit-print-color-adjust: exact;
					}
					&:not(:first-child) {
						margin-top: 1rem;
					}
					&:after {
						content: "→";
						color: $primary;
						font-weight: bold;
						position: absolute;
						right: 1.5rem;
						top: 50%;
						transform: translateY(-50%);
					}
					&:hover,
					&.active {
						background-color: $secondary;
						ul {
							li {
								background-color: $secondary;
							}
						}
					}
					&.active {
						border: 1px solid $primary;
					}

					ul {
						margin: 1rem 0 0 0;
						padding: 0;
						li {
							list-style-type: disc;
							margin-left: 2.5rem;
							margin-bottom: 0;

							margin-top: 0.4rem;
							&:not(:first-of-type) {
								margin-top: 0.4rem;
							}

							padding: 0;
							&:after {
								content: none;
							}
							&:hover {
								background-color: initial;
							}
						}
					}
				}
			}
			&.neutral {
				li {
					cursor: initial;
					padding: 0.8rem 1.2;
					&:hover {
						background-color: $grey;
						ul {
							li {
								background-color: initial;
								&:before,
								&::after {
									content: none;
								}
							}
						}
					}
					&:after {
						content: none;
					}

					&.active {
						padding: 0.8rem 1.2rem 0.8rem 3rem;
						&:before {
							content: "→";
							color: $primary;
							font-weight: bold;
							position: absolute;
							left: 0.8rem;
							top: 0.8rem;
						}
						&:hover {
							background-color: $secondary;
						}
					}
				}
			}
		}
		.description {
			background-color: $secondary;
			margin-bottom: 2.5rem;
		}
	}

	.action {
		border: 1px solid $primary;
		ul {
			li {
				list-style-type: disc;
				margin-left: 2.5rem;
				&:hover {
					background-color: transparent;
				}
			}
		}
		p {
			&:last-of-type {
				margin-top: 1rem;
				padding-top: 1rem;
				border-top: 1px solid $primary;
			}
		}
	}

	.print {
		@media print {
			display: none;
		}
	}
</style> 